import {FlowPoint, FlowWire} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';

export class WireRoute
{
    public static readonly RADIUS:number = 8;

    public from_2;
    public to_2;

    public static radius(from, to)
    {
        const delta = to - from;
        return Math.abs(delta) < WireRoute.RADIUS * 2
             ? delta / 2
             : WireRoute.RADIUS * Math.sign(delta);
    }

    constructor(public readonly from:FlowPoint,
                public readonly to:FlowPoint,
                public readonly startRadius:boolean,
                public readonly endRadius:boolean
    )
    {
        if (from.x == to.x) // vertical line
        {
            const radius = WireRoute.radius(from.y, to.y);

            if (startRadius)
                this.from_2 = new FlowPoint(from.x, from.y + radius);

            if (endRadius)
                this.to_2 = new FlowPoint(to.x, to.y - radius);
        }
        else /* if (from.y == to.y) */ // horizontal line
        {
            const radius = WireRoute.radius(from.x, to.x);

            if (startRadius)
                this.from_2 = new FlowPoint(from.x + radius, from.y);

            if (endRadius)
                this.to_2 = new FlowPoint(to.x - radius, to.y);
        }
    }
}

export class FlowWiresController
{
    public static readonly MIN_HORIZONTAL_PX_FOR_RTL_FLOW:number = 40;

    public getRouting(wire:FlowWire):WireRoute[]
    {
        const from = wire.source.position;
        const to = wire.target.position;

        const xDelta = Math.abs(to.x-from.x);
        const yDelta = Math.abs(to.y-from.y);

        const midpointX = to.x > from.x? from.x + (xDelta/2) : from.x - (xDelta/2);
        const midpointY = to.y > from.y? from.y + (yDelta/2) : from.y - (yDelta/2);

        let routes:WireRoute[] = [];

        const isLeftToRightRouting = (to.x - from.x) > FlowWiresController.MIN_HORIZONTAL_PX_FOR_RTL_FLOW;
        if( isLeftToRightRouting )
        {
            const pt0 = from;
            const pt1 = new FlowPoint(midpointX, from.y);
            const pt2 = new FlowPoint(midpointX, to.y);
            const pt3 = to;

            routes.push(new WireRoute(pt0, pt1, false, true));
            routes.push(new WireRoute(pt1, pt2, true,  true));
            routes.push(new WireRoute(pt2, pt3, true,  false));
        }
        else
        {
            const minWireLength = FlowWiresController.MIN_HORIZONTAL_PX_FOR_RTL_FLOW/2;

            const pt0 = from;
            const pt1 = new FlowPoint(pt0.x + minWireLength, pt0.y);
            const pt2 = new FlowPoint(pt1.x, midpointY);
            const pt3 = new FlowPoint(to.x - minWireLength, midpointY);
            const pt4 = new FlowPoint(pt3.x, to.y);
            const pt5 = to;

            routes.push(new WireRoute(pt0, pt1, false, true));
            routes.push(new WireRoute(pt1, pt2, true,  true));
            routes.push(new WireRoute(pt2, pt3, true,  true));
            routes.push(new WireRoute(pt3, pt4, true,  true));
            routes.push(new WireRoute(pt4, pt5, true,  false));
        }

        return routes;
    }
}
